<template>
  <div class="Login">
    <div class="content">
      <mt-field
        :label="$t('phone')"
        :placeholder="$t('phonePlaceholder')"
        v-model="form.phone"
        type="tel"
        v-mask="'#### #### #### #'"
        :state="phoneState"
      ></mt-field>
      <mt-field
        v-if="isPwd"
        :label="$t('password')"
        :placeholder="$t('passwordPlaceholder')"
        :type="!visible? 'password': 'text'"
        v-model="form.password"
        :state="passwordState"
      >
        <img v-if="!visible" class="visible" src="../../assets/notVisible.png" height="20px" @click="visible = true">
        <img v-else class="visible" src="../../assets/browse.png" height="20px" @click="visible = false">
      </mt-field>
      <template v-else>
        <mt-field :label="$t('validateCode')" v-model="form.validateCode" :state="validateCodeState">
          <mt-button type="primary" size="small" plain :disabled="!!time" @click="getSmsCode('LOGIN')">{{
            $t("smsCode")
          }}{{ time? `(${time})`: '' }}</mt-button>
        </mt-field>
        <mt-field>
          {{ $t("youCanTry") }}
          <mt-button size="small" @click="getIvrCode('LOGIN')" :disabled="!!time">{{ $t("getIvrCode") }}{{ time? `(${time})`: '' }}</mt-button>
        </mt-field>
      </template>
    </div>
    <div v-if="isPwd" class="tips" @click="isPwd = false">{{ $t('loginTips1') }}</div>
    <div v-else class="tips" @click="isPwd = true">{{ $t('loginTips2') }}</div>
    <div class="bottom">
      <mt-button type="primary" size="large" @click="submit">{{
        $t("login")
      }}</mt-button>
      <mt-button type="primary" size="large" plain @click="onPassword">{{
        $t("forgetPassword")
      }}</mt-button>
    </div>
  </div>
</template>

<script>
import { phoneRules, validateCodeRules, passwordRules } from "../../utils/rules";
import { mapMutations } from "vuex";
import { session } from '../../utils/api'
import getLocation from '../../utils/gps'
import mixin from './mixin'
export default {
  name: "Login",
  mixins: [mixin],
  props: ['value'],
  components: {},
  data() {
    return {
      isPwd: true,
      visible: false,
    };
  },
  computed: {
    phoneState() {
      this.SET_RECORD_ITEM({
        key: "loginPhone",
        value: this.form.phone,
      });
      return this.isCheck ? phoneRules(this.form.phone) : null;
    },
    validateCodeState() {
      return this.isCheck ? validateCodeRules(this.form.validateCode) : null;
    },
    passwordState() {
      this.SET_RECORD_ITEM({
        key: "loginPassword",
        value: this.form.password,
      });
      return this.isCheck ? passwordRules(this.form.password) : null;
    },
  },
  watch: {
    value() {
      this.form.phone = this.record.loginPhone || "";
      this.form.password = this.record.loginPassword || "";
    }
  },
  created() {
    this.form.phone = this.record.loginPhone || "";
    this.form.password = this.record.loginPassword || "";
  },
  methods: {
    ...mapMutations(["SET_RECORD_ITEM", "SET_ACCESS_TOKEN"]),
    onPassword() {
      this.SET_RECORD_ITEM({
        key: "passwordPhone",
        value: this.form.phone,
      });
      this.$emit('input', 'password')
    },
    async submit() {
      this.isCheck = true;
      let error, data;
      if (this.isPwd) {
        error = this.validation(['phone', 'password']);
        if (error) return this.$toast(error);
      } else {
        error = this.validation(['phone', 'validateCode']);
        if (error) return this.$toast(error);
      }
      this.$indicator.open({
        spinnerType: "fading-circle",
      });
      if (this.isPwd) {
        data = {
          loginType: "PWD_LOGIN",
          phone: this.form.phone.replace(/\s/g, ""),
          password: this.form.password,
          deviceId: "H5",
          gps: await getLocation(),
        }
      } else {
        data = {
          loginType: "CODE_LOGIN",
          phone: this.form.phone.replace(/\s/g, ""),
          code: this.form.validateCode,
          password: '',
          deviceId: "H5",
          isValidateCode: "Y",
          gps: await getLocation(),
        }
      }
      await this.$axios({
        method: "post",
        url: session,
        data: data,
      })
        .then(async (e) => {
          if (e.status.code == "000") {
            this.SET_ACCESS_TOKEN(e.body.accessToken);
            await this.getUser();
          } else {
            this.$toast(e.status.msg);
          }
        })
        .catch(() => {});
      this.$indicator.close();
    },
  },
};
</script>

<style scoped lang="scss">
.Login {
  .tips {
    text-align: center;
    color: #6B0487;
    font-size: 14px;
    margin-top: 20px;
  }
  .visible {
    margin-left: 5px;
  }
  .bottom {
    padding: 20px 0px 20px 0px;
    .mint-button {
      &:last-child {
        margin-top: 10px;
      }
    }
  }
}
</style>
